module.exports = __webpack_public_path__ + "static/img/certificate-1.dfa6973.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/certificate-1.png
// module id = fhC8
// module chunks = 1